import { AdvancedFilterConditionTypes } from '@round/ui-kit';

export type CategoriesFilterCondition = {
    type: AdvancedFilterConditionTypes;
    value: number[];
};

export function parseConditionsFromUrlString(conditions: string | undefined): CategoriesFilterCondition[] {
    if (!conditions) {
        return [];
    }

    return JSON.parse(conditions);
}

export function stringifyConditionsToUrlString(conditions: CategoriesFilterCondition[]): string | undefined {
    if (conditions.length) {
        return JSON.stringify(conditions);
    }
}
